import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { usdtContract, pepeContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import Web3 from "web3";

const AllowancePepe = () => {
  // const [balance, setBalance] = useState(null)
  const { account } = useWeb3React();
  // const web3 = useWeb3();
  const web3 = new Web3(Environment.rpc);
  const tokenAddress = Environment.presaleContract;
  const tokenAddress1 = Environment.pepe;
  const contract = pepeContract(tokenAddress1, web3);

  const allowancePepe = useCallback(async () => {
    // console.log(tokenAddress,account,'noor');
    try {
      const buy = await contract.methods
        .allowance(account, tokenAddress)
        .call();
      // console.log('sdsdss' ,  buy)
      return buy / 10 ** 18;
    } catch (error) {
      throw error;
    }
  }, [contract, account, web3]);
  return { allowancePepe: allowancePepe };
};
export default AllowancePepe;
